import CloseIcon from "assets/images/CloseIcon";
import classNames from "classnames";
import ReactModal from "react-modal";

import styles from "./StyledModal.module.css";

type Props = {
  className?: string;
  overlayClassName?: string;
  visible: boolean;
  title?: string;
  onRequestClose?: () => void;
  closeButtonClassName?: string;
  children: string | JSX.Element;
};

// TODO: Look into preventScroll
export default function StyledModal({
  className,
  overlayClassName,
  visible,
  title,
  onRequestClose,
  closeButtonClassName,
  children,
}: Props) {
  const modalStyle = classNames(
    styles.modal,
    onRequestClose ? styles.modalWithCloseButton : null,
    className,
  );
  const overlayStyle = classNames(styles.overlay, overlayClassName);

  return (
    <ReactModal
      isOpen={visible}
      className={modalStyle}
      overlayClassName={overlayStyle}
      shouldCloseOnOverlayClick={true}
      shouldCloseOnEsc={true}
      onRequestClose={onRequestClose}
      preventScroll={true}
    >
      {onRequestClose ? (
        <button
          className={classNames(styles.closeButton, closeButtonClassName)}
          onClick={onRequestClose}
        >
          <CloseIcon />
        </button>
      ) : null}
      {title ? <h2 className={styles.title}>{title}</h2> : null}
      {children}
    </ReactModal>
  );
}
